import React, { useEffect, useRef, useState } from 'react'

export function CustomCursor() {
  const dotRef  = useRef<HTMLDivElement>(null)
  const ringRef = useRef<HTMLDivElement>(null)

  const mouse   = useRef({ x: -100, y: -100 })
  const ring    = useRef({ x: -100, y: -100 })
  const rafRef  = useRef<number>(0)
  const [hovered, setHovered] = useState(false)
  const [clicked, setClicked] = useState(false)

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      mouse.current = { x: e.clientX, y: e.clientY }
    }

    const onDown = () => setClicked(true)
    const onUp   = () => setClicked(false)

    const onEnter = (e: MouseEvent) => {
      const el = e.target as HTMLElement
      if (el.closest('a, button, [role="button"], input, select, textarea')) {
        setHovered(true)
      }
    }
    const onLeave = (e: MouseEvent) => {
      const el = e.target as HTMLElement
      if (el.closest('a, button, [role="button"], input, select, textarea')) {
        setHovered(false)
      }
    }

    // Lerp ring toward mouse each frame
    const tick = () => {
      const lerp = 0.1
      ring.current.x += (mouse.current.x - ring.current.x) * lerp
      ring.current.y += (mouse.current.y - ring.current.y) * lerp

      if (dotRef.current) {
        dotRef.current.style.transform =
          `translate(${mouse.current.x}px, ${mouse.current.y}px)`
      }
      if (ringRef.current) {
        ringRef.current.style.transform =
          `translate(${ring.current.x}px, ${ring.current.y}px)`
      }

      rafRef.current = requestAnimationFrame(tick)
    }

    window.addEventListener('mousemove', onMove)
    window.addEventListener('mousedown', onDown)
    window.addEventListener('mouseup', onUp)
    window.addEventListener('mouseover', onEnter)
    window.addEventListener('mouseout', onLeave)
    rafRef.current = requestAnimationFrame(tick)

    return () => {
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mousedown', onDown)
      window.removeEventListener('mouseup', onUp)
      window.removeEventListener('mouseover', onEnter)
      window.removeEventListener('mouseout', onLeave)
      cancelAnimationFrame(rafRef.current)
    }
  }, [])

  return (
    <>
      {/* Dot */}
      <div
        ref={dotRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: hovered ? 8 : 6,
          height: hovered ? 8 : 6,
          marginLeft: hovered ? -4 : -3,
          marginTop: hovered ? -4 : -3,
          borderRadius: '50%',
          backgroundColor: hovered ? '#a5b4fc' : '#fff',
          boxShadow: '0 0 8px rgba(129,140,248,0.9)',
          pointerEvents: 'none',
          zIndex: 99999,
          transition: 'width 0.2s, height 0.2s, background-color 0.2s',
          willChange: 'transform',
        }}
      />

      {/* Ring */}
      <div
        ref={ringRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: hovered ? 48 : clicked ? 28 : 36,
          height: hovered ? 48 : clicked ? 28 : 36,
          marginLeft: hovered ? -24 : clicked ? -14 : -18,
          marginTop: hovered ? -24 : clicked ? -14 : -18,
          borderRadius: '50%',
          border: `1.5px solid ${hovered ? 'rgba(129,140,248,0.8)' : 'rgba(129,140,248,0.5)'}`,
          backgroundColor: hovered ? 'rgba(99,102,241,0.08)' : 'transparent',
          boxShadow: hovered
            ? '0 0 16px rgba(99,102,241,0.3), inset 0 0 16px rgba(99,102,241,0.05)'
            : '0 0 8px rgba(99,102,241,0.15)',
          pointerEvents: 'none',
          zIndex: 99998,
          transition: 'width 0.25s ease, height 0.25s ease, margin 0.25s ease, border-color 0.25s, background-color 0.25s, box-shadow 0.25s',
          willChange: 'transform',
        }}
      />
    </>
  )
}
